"use strict";

// side text
const sideText = document.querySelector("#mattress2024-side-navigation");
const sidePrev = document.querySelector("#mattress2024-side-navigation__prev");
const sideNext = document.querySelector("#mattress2024-side-navigation__next");

//コールバック関数
const callback = (entries) => {
  entries.forEach(({ target, isIntersecting }) => {
    const { id } = target;
    const prev = target.previousElementSibling;
    const next = target.nextElementSibling;

    sideText.classList.toggle(id, isIntersecting);
    if (!isIntersecting) return;

    const disabledPrev = (id === 'index');
    sidePrev.classList.toggle('disabled', disabledPrev);
    sidePrev.href = disabledPrev ? '#' : `#${prev?.id}`;

    const disabledNext = (id === 'checkpoint');
    sideNext.classList.toggle('disabled', disabledNext);
    sideNext.href = disabledNext ? '#' : `#${next?.id}`;
  });
};

//オプション
const options = { root: null, rootMargin: "-50% 0px" };

let observer = new IntersectionObserver(callback, options);
const targets = document.querySelectorAll(".mattress2024-content");

targets.forEach((target) => {
  observer.observe(target);
});

// ページ内リンクのオーバーライド
const isSmartPhone = () => (window.matchMedia && window.matchMedia("(max-device-width: 767px)").matches ? true : false);

const smoothScroll = (e) => {
  e.preventDefault();
  const targetId = e.currentTarget.getAttribute('href').slice(1);
  const target = document.getElementById(targetId);
  const adjust = isSmartPhone() ? 90 : 150;
  const position = target.getBoundingClientRect().top;
  const offsetPosition = position + window.scrollY - adjust;
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
};

const hashLinks = document.querySelectorAll('a[href^="#"]');
hashLinks.forEach((hashLink) => {
  hashLink.addEventListener("click", smoothScroll);
});

// Swiper JS settings
const swiper1 = new Swiper(".item-swiper1", {
  pagination: {
    el: ".pagination1",
    clickable: true,
  },
  navigation: {
    nextEl: ".next1",
    prevEl: ".prev1",
  },
});

const swiper2 = new Swiper(".item-swiper2", {
  pagination: {
    el: ".pagination2",
    clickable: true,
  },
  navigation: {
    nextEl: ".next2",
    prevEl: ".prev2",
  },
});

const swiper3 = new Swiper(".item-swiper3", {
  pagination: {
    el: ".pagination3",
    clickable: true,
  },
  navigation: {
    nextEl: ".next3",
    prevEl: ".prev3",
  },
});

const swiper4 = new Swiper(".item-swiper4", {
  pagination: {
    el: ".pagination4",
    clickable: true,
  },
  navigation: {
    nextEl: ".next4",
    prevEl: ".prev4",
  },
});
